import { pick } from 'underscore';
import { processViewModelDataForSaving } from '@bingads-webui-campaign-react/responsive-ad-editor-utils';

const whitelistedSchemaPropertyKeysForModel = [
  'Id',
  'FinalUrls',
  'MobileFinalUrls',
  'Headlines',
  'LongHeadlines',
  'Descriptions',
  'BusinessName',
  'CallToAction',
  'CallToActionLanguage',
  'TrackingUrlTemplate',
  'FinalUrlSuffix',
  'UrlCustomParameters',
  'Images',
  'Type',
];

export const viewModelToModelForMMA = (adViewModel, campaignId, adGroupId) =>
  processViewModelDataForSaving(
    pick(adViewModel, whitelistedSchemaPropertyKeysForModel),
    campaignId, adGroupId, adViewModel.Id
  );

export const bulkModelToViewModelForMMA = ({
  adModel,
  errors,
}) => ({
  ...pick(adModel, whitelistedSchemaPropertyKeysForModel),
  errors,
});
